import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false); // Mobile menu toggle
  const [setActiveDropdown] = useState(""); // Active dropdown menu

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    setActiveDropdown(""); // Close any dropdown when toggling menu
  };

  // const toggleDropdown = (dropdown) => {
  //   setActiveDropdown(activeDropdown === dropdown ? "" : dropdown);
  // };

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  return (
    <header>
      {/* Top Section: Logo and Tagline */}
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4 overflow-hidden">
          {/* Logo and Title */}
          <div className="flex items-center min-w-0 overflow-hidden">
            <Link to="/home" className="flex-shrink-0">
              <motion.img
                src="/Assets/solaris-logo.png"
                alt="Sun Logo"
                initial={{ rotate: 0 }}
                animate={{ rotate: -360 }}
                transition={{ duration: 1.2, ease: "easeInOut" }}
                className="h-14 w-14 sm:h-20 sm:w-20 mr-3"
              />
            </Link>
            <div className="truncate max-w-[70vw]">
              <h1 className="text-xl sm:text-2xl font-bold text-green-800 heading">
                Solaris <span className="heading-title">Surge</span>
              </h1>
              <p className="text-[12px] sm:text-[13px] font-bold text-black-500">
                ENERGY SOLUTIONS
              </p>
            </div>
          </div>

          {/* Hamburger Menu */}
          <button
            className="text-gray-800 md:hidden focus:outline-none ml-4 flex-shrink-0"
            onClick={toggleMenu}
          >
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-50 bg-white text-black transform ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300 md:hidden overflow-auto`}
      >
        {/* Prevent scrolling on body */}
        {/* {menuOpen
          ? (document.body.style.overflow = "")
          : (document.body.style.overflow = "auto")} */}

        <div className="flex justify-end p-6">
          <button onClick={toggleMenu}>
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </button>
        </div>

        <nav className="flex flex-col space-y-4 p-6">
          <Link to="/home" className="hover:text-gray-600">
            <strong>HOME</strong>
          </Link>
          <Link
            to="/InstallationPage"
            href="#start-here"
            className="hover:text-gray-600"
          >
            <strong>OUR INSTALLATIONS</strong>
          </Link>
          {/* <Link
            to="/learnfromus"
            href="#my-book"
            className="hover:text-gray-600"
          >
            <strong>LEARN FROM US</strong>
          </Link> */}
          {/* <Link to="/blogsection" className="hover:text-gray-600">
            <strong>BLOG</strong>
          </Link> */}

          {/* Resources Dropdown */}
          {/* <div>
            <button
              onClick={() => toggleDropdown("resources")}
              className="flex items-center justify-between w-full text-left hover:text-gray-600"
            >
              <strong>RESOURCES</strong>
              <svg
                className={`ml-2 w-4 h-4 transform transition-transform ${
                  activeDropdown === "resources" ? "rotate-180" : "rotate-0"
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            {activeDropdown === "resources" && (
              <div className="mt-2 space-y-2 pl-4">
                <Link
                  to="/installationpage"
                  href="#resource-2"
                  className="block hover:text-gray-600"
                >
                  OUR INSTALLATIONS
                </Link>
                <Link to="/diysolarparts" className="block hover:text-gray-600">
                  PARTS
                </Link>
                <Link
                  to="/diysolarresources"
                  className="block hover:text-gray-600"
                >
                  CURRENT RATINGS AND TOOLS
                </Link>
              </div>
            )}
          </div> */}

          {/* Calculators Dropdown */}
          {/* <div> */}
          {/* <button
              onClick={() => toggleDropdown("calculators")}
              className="flex items-center justify-between w-full text-left hover:text-gray-600"
            >
              <strong>CALCULATORS</strong>
              <svg
                className={`ml-2 w-4 h-4 transform transition-transform ${
                  activeDropdown === "calculators" ? "rotate-180" : "rotate-0"
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button> */}
          {/* {activeDropdown === "calculators" && (
              <div className="mt-2 space-y-2 pl-4">
                <Link
                  to="/solarcalculator"
                  className="block hover:text-gray-600"
                >
                  LOAD CALCULATOR
                </Link> */}
          {/* <Link
                  to="/calculatorcontroller"
                  className="block hover:text-gray-600"
                >
                  CHARGE CONTROLLER CALCULATOR
                </Link> */}
          {/* <Link
                  to="/solartiltanglecalculator"
                  className="block hover:text-gray-600"
                >
                  TILT ANGLE CALCULATOR
                </Link> */}
          {/* </div>
            )}
          </div> */}
          <Link
            to="/shopsection"
            href="#start-here"
            className="hover:text-gray-600"
          >
            SHOP
          </Link>
        </nav>
      </div>

      {/* Desktop Navigation */}
      <nav className="bg-green-600 hidden md:block relative z-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-12">
            <div className="flex space-x-6 text-white">
              <Link to="/home" className="hover:text-gray-300 transition">
                Home
              </Link>
              <Link
                to="/starthere"
                href="#start-here"
                className="hover:text-gray-300 transition"
              >
                Our Installations
              </Link>
              {/* <Link
                to="/learnfromus"
                href="#my-book"
                className="hover:text-gray-300 transition"
              >
                Learn From Us
              </Link> */}
              {/* <Link
                to="/blogsection"
                className="hover:text-gray-300 transition"
              >
                Blog
              </Link> */}

              {/* Resources Dropdown */}
              <div className="relative group">
                {/* Trigger */}
                {/* <div className="flex items-center hover:text-gray-300 transition cursor-pointer">
                  Resources
                  <svg
                    className="ml-2 w-4 h-4 transform transition-transform group-hover:rotate-180"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div> */}

                {/* Dropdown Menu */}
                {/* <div className="absolute left-0 z-10 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-300 bg-white text-gray-800 shadow-md mt-2 rounded-md py-2 space-y-2 w-48">
                  <Link
                    to="/installationpage"
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Our Installations
                  </Link>
                  <Link
                    to="/diysolarparts"
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Parts
                  </Link>
                  <Link
                    to="/diysolarresources"
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Current Ratings and Tools
                  </Link>
                </div> */}
              </div>

              {/* Calculators Dropdown */}
              {/* <div className="relative group">
                <div className="flex items-center hover:text-gray-300 transition cursor-pointer">
                  Calculators
                  <svg
                    className="ml-2 w-4 h-4 transform transition-transform group-hover:rotate-180"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>

                {/* Dropdown menu */}
              {/* <div className="absolute left-0 z-10 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-300 bg-white text-gray-800 shadow-md mt-2 rounded-md py-2 space-y-2 w-56">
                  <Link
                    to="/solarcalculator"
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Load Calculator
                  </Link>
                  <Link
                    to="/calculatorcontroller"
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Charge Controller Calculator
                  </Link>
                  <Link
                    to="/solartiltanglecalculator"
                    className="block px-4 py-2 hover:bg-gray-100"
                  >
                    Tilt Angle Calculator
                  </Link>
                </div>
              </div>  */}

              <Link
                to="/shopsection"
                href="#start-here"
                className="hover:text-gray-600"
              >
                Shop
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
